import Icon from '../../components/Icon.vue'

Icon.register({"regular/stop-circle":{"width":512,"height":512,"paths":[{"d":"M504 256C504 119 393 8 256 8S8 119 8 256 119 504 256 504 504 393 504 256zM56 256C56 145.5 145.5 56 256 56S456 145.5 456 256 366.5 456 256 456 56 366.5 56 256zM352 176V336C352 344.8 344.8 352 336 352H176C167.2 352 160 344.8 160 336V176C160 167.2 167.2 160 176 160H336C344.8 160 352 167.2 352 176z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/stop-circle.js
// module id = PZJ6
// module chunks = 0